import React from 'react';
import Section from '../../../../../components/outline/Section';
import Tabs from '../../../../../components/Tabs/Tabs';
import InputForm from '../../../../../components/form/InputForm';
import { formRequiredRules } from '../../../../../lib/formRules';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import { validateBrandDiscountRate, validateBrandDiscountAmount } from '../../../../../lib/utils/couponUtils';
import {
  BRAND_DISCOUNT_RATE_TYPE_SELECT_LIST,
  BRAND_DISCOUNT_RATE_TYPE,
} from '../../../../../constants/service/app/couponConstants';

const BrandSettlementSection = ({ form, discountType, discountAmount, settlementShare, setData, isEditPage }) => {
  // 쿠폰 할인 타입에 따라 브랜드 분담 타입 자동 결정
  // 0: 정액 할인 -> 정액 분담 (AMOUNT)
  // 1: 정률 할인 -> 정률 분담 (RATE)
  const autoBrandDiscountRateType =
    discountType === 1 ? BRAND_DISCOUNT_RATE_TYPE.RATE : BRAND_DISCOUNT_RATE_TYPE.AMOUNT;

  return (
    <Section className="edit-coupon-discount-type tap-section" title="브랜드 분담 설정">
      <Tabs
        tabPosition="left"
        activeKey={autoBrandDiscountRateType}
        onChange={() => {}} // 탭 변경 비활성화
        list={BRAND_DISCOUNT_RATE_TYPE_SELECT_LIST.map((item) => ({
          title: item.name,
          content: (
            <>
              {autoBrandDiscountRateType === item.id ? (
                <>
                  <div className="setting">
                    <span className="text">브랜드가</span>
                    {isEditPage ? (
                      // edit 페이지에서는 읽기 전용 텍스트만 표시
                      <span className="text">
                        <strong>
                          {settlementShare?.shareAmount || 0}
                          {item.id === BRAND_DISCOUNT_RATE_TYPE.RATE ? '%' : '원'}
                        </strong>
                      </span>
                    ) : (
                      // 생성 페이지에서는 InputForm 표시
                      <InputForm
                        type="number"
                        form={form}
                        style={{ width: 120 }}
                        rules={[
                          formRequiredRules(autoBrandDiscountRateType !== null, REQUIRED_MSG, false),
                          // 정률 할인 + 정률 분담: 쿠폰 할인율을 넘을 수 없음
                          ...(discountType === 1 && item.id === BRAND_DISCOUNT_RATE_TYPE.RATE
                            ? [validateBrandDiscountRate(discountAmount)]
                            : []),
                          // 정액 할인 + 정액 분담: 쿠폰 할인액을 넘을 수 없음
                          ...(discountType === 0 && item.id === BRAND_DISCOUNT_RATE_TYPE.AMOUNT
                            ? [validateBrandDiscountAmount(discountAmount)]
                            : []),
                        ]}
                        min={0}
                        max={item.id === BRAND_DISCOUNT_RATE_TYPE.RATE ? 100 : 1000000}
                        step={item.id === BRAND_DISCOUNT_RATE_TYPE.RATE ? 1 : 10}
                        initialValue={settlementShare?.shareAmount || 0}
                        onChange={(value) => {
                          setData({
                            name: 'settlementShare',
                            value: {
                              shareType:
                                autoBrandDiscountRateType === BRAND_DISCOUNT_RATE_TYPE.RATE ? 'rate' : 'amount',
                              shareAmount: value,
                            },
                          });
                          // 쿠폰 할인률 validation 재검증
                          setTimeout(() => {
                            form.validateFields(['discountAmount']);
                          }, 0);
                        }}
                        addonAfter={item.id === BRAND_DISCOUNT_RATE_TYPE.RATE ? '%' : '원'}
                        isEditable={true}
                        name="settlementShareAmount"
                      />
                    )}
                    <span className="text">
                      {item.id === BRAND_DISCOUNT_RATE_TYPE.RATE ? '비율로 분담합니다.' : '만큼 분담합니다.'}
                    </span>
                  </div>
                </>
              ) : (
                <div className="info">
                  {item.id === BRAND_DISCOUNT_RATE_TYPE.AMOUNT
                    ? '정액 분담은 브랜드가 고정된 금액을 분담하는 방식입니다.'
                    : '정률 분담은 브랜드가 할인 금액의 일정 비율을 분담하는 방식입니다.'}
                </div>
              )}
            </>
          ),
        }))}
      />
    </Section>
  );
};

export default BrandSettlementSection;
